import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\AccessoryController::forEquipment
* @see app/Http/Controllers/Api/AccessoryController.php:18
* @route '/api/accessories/equipment/{equipment}'
*/
export const forEquipment = (args: { equipment: number | { id: number } } | [equipment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: forEquipment.url(args, options),
    method: 'get',
})

forEquipment.definition = {
    methods: ["get","head"],
    url: '/api/accessories/equipment/{equipment}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\AccessoryController::forEquipment
* @see app/Http/Controllers/Api/AccessoryController.php:18
* @route '/api/accessories/equipment/{equipment}'
*/
forEquipment.url = (args: { equipment: number | { id: number } } | [equipment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { equipment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { equipment: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            equipment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        equipment: typeof args.equipment === 'object'
        ? args.equipment.id
        : args.equipment,
    }

    return forEquipment.definition.url
            .replace('{equipment}', parsedArgs.equipment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\AccessoryController::forEquipment
* @see app/Http/Controllers/Api/AccessoryController.php:18
* @route '/api/accessories/equipment/{equipment}'
*/
forEquipment.get = (args: { equipment: number | { id: number } } | [equipment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: forEquipment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\AccessoryController::forEquipment
* @see app/Http/Controllers/Api/AccessoryController.php:18
* @route '/api/accessories/equipment/{equipment}'
*/
forEquipment.head = (args: { equipment: number | { id: number } } | [equipment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: forEquipment.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\AccessoryController::byType
* @see app/Http/Controllers/Api/AccessoryController.php:87
* @route '/api/accessories/type/{type}'
*/
export const byType = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: byType.url(args, options),
    method: 'get',
})

byType.definition = {
    methods: ["get","head"],
    url: '/api/accessories/type/{type}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\AccessoryController::byType
* @see app/Http/Controllers/Api/AccessoryController.php:87
* @route '/api/accessories/type/{type}'
*/
byType.url = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { type: args }
    }

    if (Array.isArray(args)) {
        args = {
            type: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
    }

    return byType.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\AccessoryController::byType
* @see app/Http/Controllers/Api/AccessoryController.php:87
* @route '/api/accessories/type/{type}'
*/
byType.get = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: byType.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\AccessoryController::byType
* @see app/Http/Controllers/Api/AccessoryController.php:87
* @route '/api/accessories/type/{type}'
*/
byType.head = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: byType.url(args, options),
    method: 'head',
})

const accessories = {
    forEquipment: Object.assign(forEquipment, forEquipment),
    byType: Object.assign(byType, byType),
}

export default accessories